import React from "react";
import ConfigForm, { ConfigInput } from "components/Layout/ConfigForm";
import FormHelperText from "@material-ui/core/FormHelperText";

interface BasicTaskConfigProps {
  handleTaskNameChange: (name: string) => void;
  handleTaskPriorityChange: (priority: "1" | "2" | "3" | "4") => void;
}
interface BasicTaskConfigState {
  name: string;
  priority: "1" | "2" | "3" | "4";
}

const DEFAULT_STATE: BasicTaskConfigState = {
  name: "",
  priority: "3",
};

export const priorityLevels = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
];

export default function BasicTaskConfig(props: BasicTaskConfigProps) {
  const [state, setState] = React.useState<BasicTaskConfigState>(DEFAULT_STATE);
  const handleTaskNameChange = (event: any) => {
    setState({ ...state, name: event.target.value });
    props.handleTaskNameChange(event.target.value);
  };

  const handleTaskPriorityChange = (event: any) => {
    setState({ ...state, priority: event.target.value });
    props.handleTaskPriorityChange(event.target.value as "1" | "2" | "3" | "4");
  };

  const inputs: ConfigInput[] = [
    {
      helperText: "Required",
      title: "Task Name",
      type: "text",
      placeholder: "Required",
      required: true,
      onChange: handleTaskNameChange,
      xs: 12,
      sm: 6,
      id: "taskName",
      value: state.name,
    },
    {
      title: "Select Role Type",
      type: "select",
      onChange: handleTaskPriorityChange,
      xs: 12,
      sm: 6,
      id: "taskPriority",
      placeholder: "Select task priority level",
      options: priorityLevels,
      value: state.priority,
    },
  ];
  return <ConfigForm inputs={inputs}></ConfigForm>;
}
